import { mockReferralDB } from './mockDb';
import type { RefPartner, RefPartnerFormData } from '../types';

export const partnerService = {
  async getAll(): Promise<RefPartner[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getPartners();
  },

  async getById(id: string): Promise<RefPartner> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const partner = mockReferralDB.getPartner(id);
    if (!partner) throw new Error('Partner not found');
    return partner;
  },

  async getByCode(code: string): Promise<RefPartner | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getPartnerByCode(code) || null;
  },

  async create(data: RefPartnerFormData): Promise<RefPartner> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockReferralDB.createPartner(data);
  },

  async update(id: string, data: Partial<RefPartnerFormData>): Promise<RefPartner> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updatePartner(id, data);
    if (!updated) throw new Error('Partner not found');
    return updated;
  },

  async delete(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updatePartner(id, { active: false });
    if (!updated) throw new Error('Partner not found');
  },
};
